import { z } from 'zod';

/**
 * Shape of `GET /api/health`.
 *
 * This is the first contract shared by the API and the front-end, and it exists
 * mostly to prove the workspace chain end to end: the API builds its response
 * through this schema and the web app parses the response with it, so a Docker
 * build that breaks the `workspace:*` link fails here instead of in production.
 *
 * `commit` is the git SHA baked into the image at build time. The deploy smoke
 * test compares it against the SHA of the workflow run — that is what stops a
 * green deploy from reporting success over a stale image.
 */
export const healthResponseSchema = z.object({
  status: z.literal('ok'),
  service: z.string().min(1),
  env: z.string().min(1),
  version: z.string().min(1),
  commit: z.string().min(1),
  uptimeSeconds: z.number().nonnegative(),
  timestamp: z.string().datetime(),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;
